import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild, ViewContainerRef } from '@angular/core';
import { DynamicColumnDirective } from '../../directives/dynamic-column.directive';
import { TextColumnMoleculeComponent } from '../text-column-molecule/text-column-molecule.component';
import { ImageColumnMoleculeComponent } from '../image-column-molecule/image-column-molecule.component';
import { PercentageColumnMoleculeComponent } from '../percentage-column-molecule/percentage-column-molecule.component';
import { StateColumnMoleculeComponent } from '../state-column-molecule/state-column-molecule.component';
import { PinsColumnMoleculeComponent } from '../pins-column-molecule/pins-column-molecule.component';
import { OpenpoColumnMoleculeComponent } from '../openpo-column-molecule/openpo-column-molecule.component';
import { DecisionColumnMoleculeComponent } from '../decision-column-molecule/decision-column-molecule.component';
import { CreateWorkorderColumnMoleculeComponent } from '../create-workorder-column-molecule/create-workorder-column-molecule.component';
import { PlannedEtaColumnMoleculeComponent } from '../planned-eta-column-molecule/planned-eta-column-molecule.component';
import { UnavailableSkucodesColumnMoleculeComponent } from '../unavailable-skucodes-column-molecule/unavailable-skucodes-column-molecule.component';
import { AnalysisColumnMoleculeComponent } from '../analysis-column-molecule/analysis-column-molecule.component';
import { CurrencyColumnMoleculeComponent } from '../currency-column-molecule/currency-column-molecule.component';
import { NavigateColumnMoleculeComponent } from '../navigate-column-molecule/navigate-column-molecule.component';
import { NumberColumnMoleculeComponent } from '../number-column-molecule/number-column-molecule.component';
import { CustomNormValueColumnMoleculeComponent } from '../custom-norm-value-column-molecule/custom-norm-value-column-molecule.component';
import { ActionColumnMoleculeComponent } from '../action-column-molecule/action-column-molecule.component';

@Component({
  selector: 'app-dynamic-column-molecule',
  templateUrl: './dynamic-column-molecule.component.html',
  styleUrls: ['./dynamic-column-molecule.component.scss']
})
export class DynamicColumnMoleculeComponent implements OnChanges {
  @Input() columnType!: string;
  @Input() data!: any;
  @Input() header!: any;
  @Input() cachedPinCounts!: any;
  @Input() reportName: any;
  @Input() workOrderData: { [sku: string]: string } = {};
  @Input() readOnlyMode!: any;
  @Input() dynamicNormForm: any;
  @Input() isOptionRequired: boolean = false;
  @Input() updateGrid!: (material: string, field: string, value: any) => void;
  @Output() refreshPins: EventEmitter<void> = new EventEmitter<void>();
  @Output() onPopup: EventEmitter<{ header: any; fieldData: any }> = new EventEmitter();
  @Output() dataEmitForSalesEvent = new EventEmitter<{}>();
  @Output() dataEmitForDynamicNormReview = new EventEmitter<{}>();
  @Output() edit = new EventEmitter<any>();
  @Output() delete = new EventEmitter<any>();
  @ViewChild(DynamicColumnDirective, { static: true })
  dynamicColumn!: DynamicColumnDirective;

  private componentMap: any = {
    text: TextColumnMoleculeComponent,
    image: ImageColumnMoleculeComponent,
    percentage: PercentageColumnMoleculeComponent,
    state: StateColumnMoleculeComponent,
    pins: PinsColumnMoleculeComponent,
    openPO: OpenpoColumnMoleculeComponent,
    decision: DecisionColumnMoleculeComponent,
    createWO: CreateWorkorderColumnMoleculeComponent,
    plannedETA: PlannedEtaColumnMoleculeComponent,
    unavailableSkuCodes: UnavailableSkucodesColumnMoleculeComponent,
    analysis: AnalysisColumnMoleculeComponent,
    currency: CurrencyColumnMoleculeComponent,
    navigate: NavigateColumnMoleculeComponent,
    number: NumberColumnMoleculeComponent,
    customNorm: CustomNormValueColumnMoleculeComponent,
    action: ActionColumnMoleculeComponent
  };

  constructor(private viewContainerRef: ViewContainerRef) { }

  ngOnInit() {
    this.loadComponent();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['columnType'] || (changes['cachedPinCounts'] && this.cachedPinCounts) || changes['isOptionRequired']) {
      this.loadComponent();
    }
  }
  loadComponent() {
    const componentType = this.componentMap[this.columnType] || TextColumnMoleculeComponent;
    this.viewContainerRef.clear();

    const componentRef = this.viewContainerRef.createComponent(componentType);
    if (componentRef.instance) {
      (componentRef.instance as any).data = this.data;
      (componentRef.instance as any).header = this.header;
      (componentRef.instance as any).cachedPinCounts = this.cachedPinCounts;
      (componentRef.instance as any).reportName = this.reportName;
      (componentRef.instance as any).workOrderData = this.workOrderData;
      (componentRef.instance as any).readOnlyMode = this.readOnlyMode;
      (componentRef.instance as any).dynamicNormForm = this.dynamicNormForm;
      (componentRef.instance as any).isOptionRequired = this.isOptionRequired;



      if (this.updateGrid) {
        (componentRef.instance as any).updateGrid = this.updateGrid;
      }
      if (this.columnType === 'pins') {
        (componentRef.instance as any).fetchPinCount.subscribe(() => {
          this.refreshPins.emit();
        });
      }
      if (this.columnType === 'decision') {
        (componentRef.instance as any).popupClicked.subscribe((event) => {
          this.onPopup.emit(event);
        });
      }
      if(this.columnType === 'analysis'){
        (componentRef.instance as any).dataEmitForSalesEvent.subscribe((event) => {
          this.dataEmitForSalesEvent.emit(event);
        });
      }
      if(this.columnType === 'customNorm'){
        (componentRef.instance as any).dataEmitForDynamicNormReview.subscribe((event) => {
          this.dataEmitForDynamicNormReview.emit(event);
        });
      }
      if(this.columnType === 'action'){
        (componentRef.instance as any).edit.subscribe((event) => {
          this.edit.emit(event);
        });
        (componentRef.instance as any).delete.subscribe((event) => {
          this.delete.emit(event);
        });
        (componentRef.instance as any).dataEmitForDynamicNormReview.subscribe((event) => {
          this.dataEmitForDynamicNormReview.emit(event);
        });
      }
    }
  }
}
